import { useQuery } from "@tanstack/react-query";
import { DataLakes } from "@graylog/enterprise-api";
import useFeature from "hooks/useFeature";
import { INTERNAL_DATA_LAKE_INFO } from "data-lake/Constants";
const fetchDataLakesList = () => DataLakes.getActive().then(
  (dataLakes) => dataLakes.map((dataLake) => ({
    ...dataLake,
    storageType: dataLake.storage_type
  }))
);
const useActiveDataLakes = () => {
  const featureIsEnabled = useFeature("external_data_lake_search");
  const defaultData = featureIsEnabled ? [] : [INTERNAL_DATA_LAKE_INFO];
  const { data = defaultData, isLoading } = useQuery({
    queryKey: ["data-lake", "infos"],
    queryFn: fetchDataLakesList,
    enabled: featureIsEnabled
  });
  return {
    data,
    isInitialLoading: isLoading,
    hasActiveDataLake: (data == null ? void 0 : data.length) > 0
  };
};
export default useActiveDataLakes;
